import { hasValue } from '@famly/stat_ts-utils_has-value';
export const map = (responsiveValue, mapFn) => {
    if (!hasValue(responsiveValue)) {
        return undefined;
    }
    if (hasBreakpointsValue(responsiveValue)) {
        const [base, mobileLandscape, tabletPortrait, tabletLandscape, laptop] = toArray(responsiveValue).map(v => !hasValue(v) ? v : mapFn(v));
        return { base, mobileLandscape, tabletPortrait, tabletLandscape, laptop };
    }
    return mapFn(responsiveValue);
};
const toArray = (bpv) => {
    const { base, mobileLandscape, tabletPortrait, tabletLandscape, laptop } = bpv;
    return [base, mobileLandscape, tabletPortrait, tabletLandscape, laptop];
};
const stringIsBreakpoint = (str) => {
    switch (str) {
        case 'base':
        case 'mobileLandscape':
        case 'tabletPortrait':
        case 'tabletLandscape':
        case 'laptop':
        case 'xl':
            return true;
        default:
            return false;
    }
};
const hasBreakpointsValue = (prop) => {
    return typeof prop === 'object' && Object.keys(prop).some(stringIsBreakpoint);
};
